import React, { Component } from "react";
import { check } from "@xams-utils/check-types";

import { MfaCurrentProvider } from "./mfa-current-provider";

import { settingsApi } from "libs/api/interface/api-settings";

import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";

import { MFA_AUTHENTICATION_TYPES } from "constants/multi-factor-authentication";
import { MfaProviders } from "./mfa-providers";
import {MESSAGE_IDS} from 'constants/message-ids'

const getDefaultProvider = () => {
    return MFA_AUTHENTICATION_TYPES["APP"];
};

class MfaNotEnabled extends Component {
    state = { providers: null, provider: null, tab: null };

    constructor(props) {
        super(props);

        this.handleChangeProvider = this.handleChangeProvider.bind(this);
    }

    componentDidMount() {
        const { orgId, userEmail } = this.props;
        settingsApi
            .getMfaProviders(orgId)
            .then((response) => {
                let providers = null;
                let provider = null;
                let tab = null;

                if (check.nonEmptyString(response)) {
                    const parsedResponse = JSON.parse(response);

                    if (check.nonEmptyObject(parsedResponse)) {
                        const { value } = parsedResponse;
                        // const value = "App,Email";

                        if (check.nonEmptyString(value)) {
                            const items = value
                                .split(",")
                                .map((item) => item.trim().toUpperCase())
                                .reduce((items, item) => {
                                    if (check.nonEmptyString(item)) {
                                        if (
                                            check.assigned(
                                                MFA_AUTHENTICATION_TYPES[item]
                                            )
                                        ) {
                                            if (
                                                MFA_AUTHENTICATION_TYPES[
                                                    item
                                                ] !==
                                                    MFA_AUTHENTICATION_TYPES.EMAIL ||
                                                check.nonEmptyString(userEmail)
                                            ) {
                                                items.push(
                                                    MFA_AUTHENTICATION_TYPES[
                                                        item
                                                    ]
                                                );
                                            }
                                        }
                                    }

                                    return items;
                                }, []);

                            if (check.nonEmptyArray(items)) {
                                if (items.length > 1) {
                                    providers = items;
                                }
                                provider = items[0];
                                tab = 0;
                            }
                        }
                    }
                }

                if (!provider) {
                    provider = getDefaultProvider();
                }

                this.setState({ provider, providers, tab });
            })
            .catch(() => {
                this.setState({ provider: getDefaultProvider() });
            });
    }

    handleChangeProvider(provider) {
        this.setState({ provider });
    }

    displayAvailableProviders() {
        const { providers, provider } = this.state;

        if (!check.nonEmptyArray(providers)) {
            return null;
        }

        const props = {
            providers,
            provider,
            onChange: this.handleChangeProvider,
        };
        return <MfaProviders {...props} />;
    }

    displayCurrentProvider() {
        const { provider } = this.state;
        const { userId, orgId, onVerify, messages } = this.props;
        const props = { provider, userId, orgId, onVerify, enabled: false, messages };

        return <MfaCurrentProvider {...props} />;
    }

    displayTitle() {
        const {messages}=this.props;
        const props = { title: messages[MESSAGE_IDS.MFA.TITLE_NOT_ENABLED] };

        return <CardHeader {...props} />;
    }

    render() {
        const { provider } = this.state;

        if (check.number(provider)) {
            const { classes } = this.props;

            return (
                <React.Fragment>
                    {this.displayTitle()}
                    <CardContent className={classes.cardContent}>
                        {this.displayAvailableProviders()}
                        {this.displayCurrentProvider()}
                    </CardContent>
                </React.Fragment>
            );
        }

        return null;
    }
}

export { MfaNotEnabled };
